export class DocViewDto {
    documentId: string;
    szDlpRefernceNo: string;
    szDocCode: string;
    documentName: string;
    documentType: string;
    document: string;
}